export default __webpack_public_path__ + "static/media/banner.1562ba50.svg";